import React from 'react'
import { Chip } from '@mui/material'
import { lighten } from '@mui/material/styles'

import QAPVars from 'qap/vars'

const BetaChip = () => (
  <Chip
    label='Beta'
    size='small'
    variant='outlined'
    sx={{
      ml: 1,
      height: 18,
      borderRadius: 0,
      color: QAPVars.linkBlue,
      backgroundColor: lighten(QAPVars.linkBlue, 0.9),
      borderColor: lighten(QAPVars.linkBlue, 0.5),
      textTransform: 'uppercase',
      fontSize: 10,
    }}
  />
)

export default BetaChip
